/**
 * Prefer coach-tools `profilePhoto` (CRM::Person#profile_photo) over v3
 * `photo` (Member.photo / CCMS-mirrored). The coach-tools value is written
 * immediately by `updatePerson`; v3 can lag behind backend sync.
 */
export const getDisplayPhoto = (
  { profilePhoto, photo } = {},
  fallback = null,
) => profilePhoto || photo || fallback

/**
 * After Save, reload only when coach-tools did not return a profile photo
 * and the UI was relying on the v3 `photo` fallback before save.
 */
export const shouldScheduleProfilePhotoReload = ({
  coachToolsProfilePhotoAfterSave,
  coachToolsProfilePhotoBeforeSave,
  v3PhotoBeforeSave,
}) => {
  if (coachToolsProfilePhotoAfterSave) return false
  return !coachToolsProfilePhotoBeforeSave && !!v3PhotoBeforeSave
}
